import { reactive, watch } from 'vue'
import { useScreen } from 'vue-screen'

const config = {
  sm: [320, 671],
  md: [672, 1055],
  lg: [1056, 1311],
  xlg: [1312, 1583],
  max: [1584],
  isMobile: 671,
  isTablet: [672, 1055],
  isDesktop: [1056],
}

const isValueInRange = (value, width) => {
  if (typeof value === 'number') {
    return width < value
  }

  if (Array.isArray(value) && value.length === 2) {
    return value[0] <= width && width <= value[1]
  }

  if (Array.isArray(value) && value.length === 1) {
    return value[0] <= width
  }

  throw new Error(`None of the conditions match the given value: ${value}`)
}

export default function useMQ() {
  const mq = reactive({})
  const screen = useScreen()

  Object.entries(config).forEach(([key, rawValue]) => {
    mq[key] = isValueInRange(rawValue, screen.width)
  })

  watch(
    () => screen.width,
    width => {
      Object.entries(config).forEach(([key, rawValue]) => {
        mq[key] = isValueInRange(rawValue, width)
      })
    },
  )

  return {
    mq,
  }
}
